<template>
  <div class="home">
    <div class="vipTitle">会员</div>
    <img class="vipBanner" :src="yuakalist.buyImg" />
    <div class="tab-container">
      <button v-for="(item, index) in vipPics.vipGroupList" :key="index" :class="{ active: isActiveTab(index) }"
        @click="setActiveTab(index)">
        {{ item.vipName }}
      </button>
    </div>
    <!-- <img style="font-size: 12px; width: 90%; margin: 15px auto 0" class="vipBanner" :src="yuakalist.buyImg" /> -->

    <div class="input_img-yueka">
      <div style="" :class="active == index ? 'activeyue bg' : 'bg'" v-for="(item, index) in yuakalist.vipModelList"
        :key="index" @click="activeClick(item, index)">
        <span class="input_img-yueka-year">{{
          item.vipType == 1 ? "月会员卡" : "连续包月"
        }}</span>
        <div class="input_img-yueka-num">
          <span style="font-size: 16px; position: relative; left: 10px">￥</span>
          <span> {{ item.price }}</span>
        </div>
      </div>
    </div>
    <div style="font-size: 12px; width: 90%; margin: 15px auto 0" v-if="vipobj.vipType != 1">
      到期按{{ vipobj.price }}元/月每月续费，可随时取消。
    </div>
    <div style="font-size: 12px; width: 90%; margin: 15px auto 0">
      <span style="vertical-align: text-bottom"><input type="checkbox" v-model="isChecked" /></span>
      <span @click="urlOpen(1)">《会员协议》</span><span
        style="line-height: 18px" @click="urlOpen(2)">《连续包月服务协议》</span>
    </div>
    <div class="vip-buy">
      <div>
        <div>
          <span style="color: #7e7e7e">合计：</span>
          <span style="color: #ec351e; font-weight: 600">￥</span>
          <span style="color: #ec351e; font-size: 22px; font-weight: 600">
            {{ vipobj.price }}</span>
        </div>
        <div style="font-size: 14px; color: black; font-weight: 600; margin-top: 3px">
          {{ vipobj.vipType == 1 ? "开通单次月卡" : "开通连续包月" }}
        </div>
      </div>
      <img style="width: 60%" @click="getVipUrl(vipobj.buyUrl, vipobj)" src="../assets/vipbtn.png" alt="" />
    </div>
    <img :src="vipobj.detailImg" />
    <FootTab></FootTab>
    <el-dialog :visible.sync="centerDialogVisible" width="80%" center>
      <div class="dialog-content">
        <el-input size="medium" v-model="input1" placeholder="请输入手机号"></el-input>
        <el-input size="medium" v-model="input2" placeholder="请输入银行卡号"></el-input>
        <!-- <el-select
          style="width: 100%"
          v-model="value"
          filterable
          placeholder="请选择银行卡"
        >
          <el-option
            size="medium"
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <el-input size="medium" v-model="input3" placeholder="请输入身份证姓名"></el-input>
        <el-input size="medium" v-model="input4" placeholder="请输入身份证号"></el-input>
        <div style="display: flex; justify-content: space-between; align-items: center">
          <el-input size="medium" v-model="input5" placeholder="请输入验证码"></el-input>
          <div class="getcode" @click="codeClick">
            {{ vscode != "发送验证码" ? vscode + " s" : vscode }}
          </div>
        </div>
        <img class="buttonClick" @click="buttonClick" src="@/assets/vipButton.png" alt="" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import FootTab from "@/components/FootTab.vue";
import wx from "weixin-js-sdk";
import axios from "axios";
import VConsole from "../assets/js/vconsole.min.js";
var gzhstate;
export default {
  name: "home",
  components: {
    FootTab,
  },
  data() {
    return {
      title: "",
      userMes: [],
      vipPics: {
        vipModelList: [{ buyCount: 0 }],
      },

      isLiantong: true,

      isShowHasbuy: true,

      tabs: [
        { title: "黄金会员", content: "这是第一个内容" },
        { title: "白金会员", content: "这是第二个内容" },
      ],
      activeTab: 0,
      yuakalist: [],
      active: 0,
      vipobj: {},
      isChecked: false,
      centerDialogVisible: false,
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      input5: "",
      vscode: "发送验证码",
      timer: null,
      vipCode: "",
      orderNo: "",
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      value: "",
    };
  },
  created() { },
  mounted() {
    // new VConsole();
    // 公众号支付
    gzhstate = this.AllgetQueryId("state");
    const ua = navigator.userAgent.toLowerCase();
    // 微信小程序环境
    if (ua.match(/miniprogram/i)) {
      console.log("小程序");
    } else if (ua.match(/micromessenger/i)) {
      console.log("微信浏览器环境");
      gzhstate = true
    } else {
      console.log("普通浏览器环境");
    }
    if (gzhstate) {
      this.wxgzh();
      sessionStorage.setItem("gzhstate", gzhstate);
    }
    // 获取用户信息
    this.http.getUserMes().then((res) => {
      if (res.data.status == 1) {
        this.userMes = res.data.data;
      }
    });
    // 获取2个Vip
    this.http.getVipList().then((res) => {
      this.vipPics = res.data.data;
      this.yuakalist = res.data.data.vipGroupList[0];
      this.vipobj = res.data.data.vipGroupList[0].vipModelList[0];
    });

    if (eval("(" + localStorage.getItem("channelMes") + ")").id == 5) {
      this.isShowHasbuy = false;
    }
  },
  methods: {
    buttonClick() {
      if (this.input1 == "" || this.input1.length != 11) {
        this.$message({
          showClose: true,
          message: "请输入手机号",
          type: "error",
        });
        return;
      }
      if (this.input2 == "") {
        this.$message({
          showClose: true,
          message: "请输入银行卡号",
          type: "error",
        });
        return;
      }
      if (this.input3 == "") {
        this.$message({
          showClose: true,
          message: "请输入身份证姓名",
          type: "error",
        });
        return;
      }
      if (this.input4 == "") {
        this.$message({
          showClose: true,
          message: "请输入身份证号",
          type: "error",
        });
        return;
      }
      if (this.input5 == "") {
        this.$message({
          showClose: true,
          message: "请输入验证码",
          type: "error",
        });
        return;
      }
      let data = {
        orderNo: this.orderNo,
        vcode: this.input5,
      };
      this.http.tonglianConfirm(data).then((res) => {
        console.log(res, "222");
        if (res.data.status == 1) {
          this.$router.push({ name: "mine" });
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    codeClick() {
      if (this.input1 == "" || this.input1.length != 11) {
        this.$message({
          showClose: true,
          message: "请输入手机号",
          type: "error",
        });
        return;
      }
      if (this.input2 == "") {
        this.$message({
          showClose: true,
          message: "请输入银行卡号",
          type: "error",
        });
        return;
      }
      if (this.input3 == "") {
        this.$message({
          showClose: true,
          message: "请输入身份证姓名",
          type: "error",
        });
        return;
      }
      if (this.input4 == "") {
        this.$message({
          showClose: true,
          message: "请输入身份证号",
          type: "error",
        });
        return;
      }
      let data = {
        sendPhone: this.input1,
        accountName: this.input3,
        accountId: this.input4,
        accountNo: this.input2,
        vipCode: this.vipCode, //编码
      };
      if (this.vscode != "发送验证码") {
        return;
      }
      this.http.tonglianOrder(data).then((res) => {
        if (res.data.status == 1) {
          this.orderNo = res.data.data.orderNo;
          this.checkcode();
        } else {
          this.$message({
            showClose: true,
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    //验证码倒计时
    checkcode() {
      const TIME_COUNT = 60;
      let than = this;
      if (!than.timer) {
        than.vscode = TIME_COUNT;
        than.timer = setInterval(() => {
          if (than.vscode > 0 && than.vscode <= TIME_COUNT) {
            this.vscode--;
          } else {
            clearInterval(this.timer);
            than.timer = null;
            than.vscode = "发送验证码";
          }
        }, 1000);
      }
    },
    wxgzh() {
      let than = this;
      let code = than.AllgetQueryId("code"); //去地址栏拿code
      let url = window.location.href;
      if (code == null) {
        this.http.getCode({ redirectUri: url }).then((res) => {
          window.location.href = res.data.data;
        }).catch((error) => {
          // 处理错误
          alert(error)
          //   console.error("失败：", error);
        });
      } else {
        this.http.userOpenid({ code: code }).then((res) => { });
      }
    },
    urlOpen(index) {
      let url = ''
      if(index == 1){
        if (location.href.indexOf("hemakouyu") != -1) {
          url = 'https://wxh5.ygxzb.cn/yinsi3.html'
        }else{
          url = 'https://wxh5.ygxzb.cn/yinsi1.html'
        }
      }
      if(index == 2){
       if (location.href.indexOf("hemakouyu") != -1) {
          url = 'https://wxh5.ygxzb.cn/yinsi4.html'
        }else{
          url = 'https://wxh5.ygxzb.cn/yinsi2.html'
        }
      }
      window.open(url);
    },
    // 产品切换
    activeClick(item, index) {
      this.vipobj = item;
      this.active = index;
    },
    // 会员切换
    setActiveTab(index) {
      this.active = 0;
      this.activeTab = index;
      this.yuakalist = this.vipPics.vipGroupList[index];
      this.vipobj = this.vipPics.vipGroupList[index].vipModelList[0];
    },
    isActiveTab(index) {
      return this.activeTab == index;
    },
    playAudio() {
      this.isPlay = true;
      const music = this.$refs.player; // 音频所在对象
      music.play(); // 暂停音乐
    },
    getVipUrl(url, item) {
      if (this.isChecked == false) {
        this.$message({
          showClose: true,
          message: "请勾选协议",
          type: "error",
        });
        return;
      }
      if (item.status == 2) {
        this.$message({
          showClose: true,
          message: "暂未开通",
          type: "error",
        });
        return;
      }
      if (item.payType == 3) {
        this.centerDialogVisible = true;
        this.vipCode = item.vipCode;
        return;
      }
      let buyImg = url;
      const currentProtocol = window.location.protocol;
      const updatedBuyImg = buyImg.replace(/^https?:/, currentProtocol);
      let that = this;
      var state = false; //是否嵌套在小程序里
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram == true) {
          state = true;
        }
      });
      if (!this.isLiantong) {
        return;
      }
      if (this.userMes.phone) {
        // 获取vip地址
        this.http
          .getVipUrl({
            redirectUri: updatedBuyImg,
          })
          .then((res) => {
            if (res.data.status == 1) {
              gzhstate = sessionStorage.getItem("gzhstate");
              let dataA = {
                userId: this.userMes.id,
                wxPayModel: 2, //1是h5 2是微信
              };
              if (state == true) {
                dataA.wxPayModel = 2;
              } else {
                if (gzhstate) {
                  dataA.wxPayModel = 3;
                } else {
                  dataA.wxPayModel = 1;
                }
              }
              console.log(gzhstate);
              axios
                .get(res.data.msg, { params: dataA })
                .then((response) => {
                  if (response.data.status == 1) {
                    var sta = "";
                    // 小程序支付
                    if (state == true) {
                      if (response.data.data.appid) {
                        // 连续包月
                        sta =
                          "?appid=" +
                          response.data.data.appid +
                          "&contract_code=" +
                          response.data.data.contract_code +
                          "&contract_display_account=" +
                          encodeURIComponent(
                            response.data.data.contract_display_account
                          ) +
                          "&mch_id=" +
                          response.data.data.mch_id +
                          "&notify_url=" +
                          encodeURIComponent(response.data.data.notify_url) +
                          "&plan_id=" +
                          response.data.data.plan_id +
                          "&request_serial=" +
                          response.data.data.request_serial +
                          "&sign=" +
                          response.data.data.sign +
                          "&timestamp=" +
                          response.data.data.timestamp;
                      } else {
                        //单笔支付
                        sta =
                          "?timeStamp=" +
                          response.data.data.timeStamp +
                          "&nonceStr=" +
                          response.data.data.nonceStr +
                          "&package=" +
                          encodeURIComponent(response.data.data.package) +
                          "&signType=" +
                          response.data.data.signType +
                          "&paySign=" +
                          encodeURIComponent(response.data.data.paySign);
                      }
                      // 跳转到微信小程序环境内
                      wx.miniProgram.navigateTo({ url: "/pages/pay/pay" + sta });
                    } else {
                      if (gzhstate) {
                        // 公众号支付
                        if (item.vipType == 1) {
                          //单次
                          WeixinJSBridge.invoke(
                            "getBrandWCPayRequest",
                            {
                              appId: response.data.data.appId, //公众号ID，由商户传入
                              timeStamp: response.data.data.timeStamp, //时间戳，自1970年以来的秒数
                              nonceStr: response.data.data.nonceStr, //随机串
                              package: response.data.data.package,
                              signType: response.data.data.signType, //微信签名方式：
                              paySign: response.data.data.paySign,
                            },
                            function (res) {
                              if (res.err_msg == "get_brand_wcpay_request:ok") {
                                that.$message({
                                  showClose: true,
                                  message: "支付成功",
                                  type: "error",
                                });
                                // 使用以上方式判断前端返回,微信团队郑重提示：
                                //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                              } else if (
                                res.err_msg == "get_brand_wcpay_request:cancel"
                              ) {
                                that.$message({
                                  showClose: true,
                                  message: "取消支付",
                                  type: "error",
                                });
                              } else {
                                that.$message({
                                  showClose: true,
                                  message: "支付失败",
                                  type: "error",
                                });
                              }
                            }
                          );
                        } else {
                          // 包月
                          window.location.href = response.data.data.orderUrl;
                        }
                      } else {
                        // h5支付
                        window.location.href = response.data.data.orderUrl;
                      }
                    }
                  } else {
                    that.$message({
                      showClose: true,
                      message: response.data.msg,
                      type: "error",
                    });
                  }
                })
                .catch((error) => {
                  // 处理错误
                  //   console.error("失败：", error);
                });
              // this.http.zhifuVipUrl(res.data.msg,dataA).then((res) => {
              // 		console.log(res,"zhifu55555");
              // })
              // 	vipCode:item.vipCode,
              // requrl:updatedBuyImg,
              // userId:this.userMes.id,
              // wxPayModel:2,
              // window.location.href = res.data.msg + "&userId=" + this.userMes.id;
            } else {
              that.$message({
                showClose: true,
                message: res.data.msg,
                type: "error",
              });
            }
          });
      } else {
        if (state == true) {
          //   console.log("我在小程序中");
          wx.miniProgram.navigateTo({ url: "/pages/login/login" });
        } else {
          //   console.log("我在网页中");
          sessionStorage.setItem("loginReturn", window.location.href);
          that.$router.push({ name: "login" });
        }
      }
    },
    AllgetQueryId(variable) {
      var reg = new RegExp("(^|&)" + variable + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURI(r[2]);
      }
      return null;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-input__inner {
  border-color: #cccccc !important;
  height: 36px;
  line-height: 36px;
  padding: 0px 20px !important;
}

::v-deep .el-dialog {
  border-radius: 10px;
}

.dialog-content {
  text-align: center;
  padding: 0px 0;

  .el-input {
    margin: 5px 0;
  }

  .getcode {
    width: 200px;
    height: 36px;
    line-height: 36px;
    display: block;
    border: 1px solid #ccc;
    margin-left: 10px;
    border-radius: 4px;
  }

  .buttonClick {
    margin: 20px 0 0;
  }
}

.vip-buy {
  width: 90%;
  height: 80px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tab-container {
  width: fit-content;
  margin: 0px auto;
  display: flex;
  justify-content: center;
  border-radius: 50px;
  background: #E4E5E7;
  padding: 4px 0;
}

button {
  background-color: #e2e1e1;
  color: black;
  padding: 6px 7px;
  border: none;
  margin: 0 6px;
  border-radius: 50px;
}

button.active {
  background-color: #e4d0a5;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: opacity 0.3s ease;
}

.tab-content {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
}

.tab-content.show {
  opacity: 1;
  max-height: unset;
}

.home {
  background-color: #fff;
  min-height: 100vh;
  padding-bottom: 1.46rem;
  text-align: left;

  .vipTitle {
    font-size: 0.38rem;
    text-align: center;
    font-weight: bold;
    height: 0.9rem;
    line-height: 0.9rem;
  }

  .eachVip {
    margin-top: 0.1rem;
    position: relative;

    .hasBuy {
      font-size: 0.2rem;
      color: #444240;
      position: absolute;
      top: 5rem;
      left: 5.31rem;
    }

    .toDetail {
      width: 1.55rem;
      height: 0.56rem;
      position: absolute;
      top: 1.47rem;
      right: 0.67rem;
    }
  }
}

.activeyue {
  background-image: url("../assets/vip1.png") !important;
  background-size: contain !important;
  border: 2px solid #000000 !important;

  .input_img-yueka-num {
    color: #764a03 !important;
  }
}

.input_img {
  margin: auto;
  width: 90%;
  z-index: 20;
  border-radius: 15px;
  background-size: contain;
  background-repeat: no-repeat;
  margin-top: 40px;
  position: relative;
  bottom: 30px;

  &-yueka {
    width: 92%;
    margin: auto;
    display: flex;
    justify-content: space-between;

    .bg {
      width: 160px;
      height: 112px;
      background-image: url("../assets/vip2.png");
      background-repeat: no-repeat;
      background-size: contain;
      border-radius: 10px;
      margin: 10px 4px 0;
      border: 2px solid #cceaf100;
      position: relative;
      text-align: center;
    }

    &-num {
      position: absolute;
      top: 35px;
      left: 0px;
      right: 16px;
      margin: auto;
      font-size: 30px;
    }

    &-year {
      position: absolute;
      bottom: 20px;
      left: 0px;
      right: 0px;
      font-size: 14px;
    }

    img {
      width: 80px;
    }
  }

  &>img {
    width: 50%;
    margin: auto;
    padding: 20px 0 10px;
  }
}
</style>
